import SiafLiteApiRepository from "../../external/siafLiteApi";
import encrypt from "../../utils/encrypt";

class UsuarioService {
  constructor() {
    this.urlBase = "/painel-controle/usuarios";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(filter);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(data) {
    const senha = encrypt(data.senha);
    const confirmarSenha = encrypt(data.confirmarSenha);
    const body = { ...data, senha, confirmarSenha };
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, data) {
    const senha = encrypt(data.senha);
    const confirmarSenha = encrypt(data.confirmarSenha);
    const body = { ...data, senha, confirmarSenha };
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  validarEmail(email) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-email`,
    ).patch({
      email,
    });
  }

  validarQtdUsuariosEmpresa() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/validar-qtd-usuarios-empresa`,
    ).get();
  }
}

export default UsuarioService;
